import Request from './Request';

export default class OrbitMetadataService {
    // ── Orbit App Prompts ────────────────────────────────────────────────

    /** Fetch all prompts. Pass { prompt_type, client_id, active_only } as optional filters. */
    static async listPrompts(params = {}) {
        const qs = new URLSearchParams(
            Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        ).toString();
        return Request.get(`/api/admin/orbit-metadata/prompts${qs ? '?' + qs : ''}`);
    }

    static async createPrompt(data) {
        return Request.post('/api/admin/orbit-metadata/prompts', data);
    }

    static async updatePrompt(id, data) {
        return Request.post(`/api/admin/orbit-metadata/prompts/${id}`, data);
    }

    static async deletePrompt(id) {
        return Request._delete(`/api/admin/orbit-metadata/prompts/${id}`);
    }

    // ── Orbit chat feedback admin review ─────────────────────────────────

    static async listChatFeedback(params = {}) {
        const qs = new URLSearchParams(
            Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))
        ).toString();
        return Request.get(`/api/admin/orbit-metadata/chat-feedback${qs ? '?' + qs : ''}`);
    }
}

